<template>
  <form @submit.prevent="save_event" class="mt-8">

    <label class="mt-4 mb-2 d-block bold">{{$t('EVENT.MAP_LOCATION')}}</label>
    
    <div class="mt-4">
      <memlist-radio-group
        :initial_value="local_item.location_setting"
        :items="[
          { text: $t('EVENT.ADDRESS_UNAVAILABLE'), value: 'NONE' },
          { text: $t('EVENT.ONLINE'), value: 'ONLINE' },
          { text: $t('EVENT.STREET_AND_POST'), value: 'ADDRESS' },
          { text: $t('EVENT.GEO_COORDS'), value: 'GEO' }
        ]"
        v-model="local_item.location_setting"
        @input="on_change"
      />

    </div>

    <div v-if="local_item.location_setting === 'GEO' || local_item.location_setting === 'ADDRESS'" class="mt-6 d-flex flex-wrap">
      <div class="w-100 w-md-50 pr-md-4">
        
        <div v-if="local_item.location_setting === 'GEO'" class="mt-6">
          <memlist-text-input
            name="lat"
            :title="'Latitud'"
            layout="vertical"
            validation_type="TEXT"
            v-model="local_item.lat"
            @input="on_change"
          />
          <memlist-text-input
            name="lng"
            :title="'Longitud'"
            layout="vertical"
            validation_type="TEXT"
            v-model="local_item.lng"
            @input="on_change"
          />
        </div>

        <div v-if="local_item.location_setting === 'ADDRESS'" class="mt-6">
          <memlist-text-input
            name="address"
            :title="$t('EVENT.ADDRESS')"
            layout="vertical"
            validation_type="TEXT"
            v-model="local_item.address"
            @input="on_change"
          />
          <memlist-text-input
            name="zipcode"
            :title="$t('EVENT.ZIPCODE')"
            layout="vertical"
            validation_type="TEXT"
            v-model="local_item.zipcode"
            @input="on_change"
          />
          <memlist-text-input
            name="postaladdress"
            :title="$t('EVENT.POSTAL_ADDRESS')"
            layout="vertical"
            validation_type="TEXT"
            v-model="local_item.postaladdress"
            @input="on_change"
          />
        </div>
      </div>
      <div class="w-100 w-md-50 mt-4 mt-md-0">

        <google-map
          v-if="local_item.google_maps"
          :center="{ lat: local_item.google_maps.lat, lng: local_item.google_maps.lng }"
          :zoom="16"
          style="height: 256px; width: 100%;"
          id="map"
          ref="Map"
        >
          <google-map-marker
            :position="{ lat: local_item.google_maps.lat, lng: local_item.google_maps.lng }"
          />
          <google-map-infowindow
            :position="infoWIndowContext.position"
            :show.sync="showInfo"
            :options="{ maxWidth: 300 }"
          >
            <h4>{{ infoWIndowContext.title }}</h4>
            <p>{{ infoWIndowContext.description }}</p>
          </google-map-infowindow>
        </google-map>
      </div>
    </div>


    <memlist-icon-button
      v-if="local_item.location_setting === 'ADDRESS' || local_item.location_setting === 'GEO'"
      class="mr-2 mt-4"
      icon="menu-icon flaticon2-map"
      :text="$t('EVENT.GENERATE_GOOGLE_MAPS')"
      variant="primary"
      @click="generate_google_clicked"
    />
  </form>
</template>

<script>
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import axios from 'axios';

export default {
  props: ['item'],
  mixins: [ toasts ],
  watch: {
    
    item: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.local_item = JSON.parse(JSON.stringify(this.item));
      },
      immediate: true
    },

  },
  methods: {
    save_event() {},

    on_change() {

      setTimeout(()=>{
        console.log('form has changed', this.local_item)

        if (this.local_item.location_setting !== 'ADDRESS' && this.local_item.location_setting !== 'GEO') {
          this.local_item.google_maps = { lat: 0, lng: 0 };
        }

        this.$emit('change', this.local_item);
      }, 100);
      
    },

    async generate_google_clicked() {

    if (this.local_item.location_setting === 'ADDRESS') {
      if (!this.local_item.address || !this.local_item.zipcode || !this.local_item.postaladdress) {
        this.toastr('warning', 'Google maps', this.$t('EVENT.MUST_FILL_ADDRESS'));
        return;
      }

      this.generate_google_maps(this.local_item.address, this.local_item.zipcode, this.local_item.postaladdress);
    }
    else if (this.local_item.location_setting === 'GEO') {
      this.generate_google_maps_from_lat_lng(this.local_item.google_maps.lat, this.local_item.google_maps.lng);
    }

    },

    async generate_google_maps_from_lat_lng(lat, lng) {
      try {

        const res = await axios.get(`/company/geolatlng?lat=${lat}&lng=${lng}`)
        
        if (res.status === 200) {
          this.toastr('success', 'Google Maps', this.$t('EVENT.SUCCESS_GOOGLE_MAPS'));

          this.local_item.google_maps = {
            lat: res.data.lat,
            lng: res.data.lng,
            static_link: ''
          };

          this.on_change();
          this.$emit('force_save', this.local_item);
        }
      
      }
      catch (err) {
        console.error('generate_google_maps_from_lat_lng error', err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('EVENT.UNABLE_GOOGLE_MAPS'));
      }
      
    },

    async generate_google_maps(addr, zipcode, postal) {
      try {
        const res = await axios.get(`/company/geo?address=${addr}&zipcode=${zipcode}&postaladdress=${postal}&country=SE`)
        
        if (res.status === 200) {
          this.toastr('success', 'Google Maps', this.$t('EVENT.SUCCESS_GOOGLE_MAPS'));

          this.local_item.google_maps = {
            lat: res.data.lat,
            lng: res.data.lng,
            static_link: ''
          };

          this.on_change();
          this.$emit('force_save', this.local_item);
        }
      }
      catch (err) {
        console.error('generate_google_maps error', err);
        this.toastr('danger', 'Google Maps', this.$t('EVENT.UNABLE_GOOGLE_MAPS'));
      }
      
    },
  },
  data() {
    return {

      local_item: {},
      showInfo: false,
      infoWIndowContext: {
        position: {
          lat: 44.2899,
          lng: 11.8774
        }
      },
      infoWindowsList: []
    }
  },
}
</script>
